import createAxiosInstance from './explorer-axois';

const axiosManager = createAxiosInstance({  
    baseURL: process.env.VUE_APP_BASE_URL,
    authBaseURL: process.env.VUE_APP_AUTH_BASE_URL,
});

export default axiosManager;